import { ExamTypes } from "utils/constants";

const validateTimeSlots = ({ startTime, endTime }) => {
  if (!startTime || !endTime) {
    return "Моля, въведете началния и крайния час.";
  }

  const startTimeAsNumber = +startTime.replaceAll(":", "");
  const endTimeAsNumber = +endTime.replaceAll(":", "");

  if (startTimeAsNumber >= endTimeAsNumber) {
    return "Крайният час трябва да е след началния час.";
  }
};

const shouldHaveSlots = ({ examTypeId }) => {
  return examTypeId && examTypeId === ExamTypes.InPerson;
};

const sessionExamsHelper = {
  validateTimeSlots,
  shouldHaveSlots,
};

export default sessionExamsHelper;
